import Vue from 'vue'
import axios from '@/plugins/axios'

export const find = async ({ commit }, filter) => {
  console.group('[userServices] find')
  console.log('request filter:', filter)

  try {
    const { data } = await axios.get('user-service', { params: filter })

    console.log('response data:', data)

    if (data?.userServices) {
      commit('setRows', data.userServices)

      const result = {
        userServices: data.userServices,
        isConfigured: Boolean(data.isConfigured),
      }

      console.log('parsed result:', {
        serviceIds: result.userServices.map(row => row.serviceId),
        isConfigured: result.isConfigured,
        total: result.userServices.length,
      })
      console.groupEnd()

      return result
    }

    commit('setRows', [])

    console.warn('[userServices] find: resposta sem userServices, retornando vazio')
    console.groupEnd()

    return {
      userServices: [],
      isConfigured: false,
    }
  } catch (err) {
    console.error('[userServices] find: erro na requisição', err)
    console.groupEnd()
    return err
  }
}

export const update = async (_, body) => {
  console.group('[userServices] update')
  console.log('request body:', body)
  console.log('serviceIds enviados:', body?.serviceIds)

  Vue.prototype.$loading(true)
  try {
    const response = await axios.post('user-service', body)

    console.log('response status:', response?.status)
    console.log('response data:', response?.data)
    console.groupEnd()

    return response
  } catch (err) {
    console.error('[userServices] update: erro na requisição', err)
    console.error('[userServices] update: response error', err?.response?.data)
    console.groupEnd()
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}

export const clearUserServices = async ({ commit }) => {
  commit('setRows', [])
}

